import styled from 'styled-components/native';
import { View, Text } from 'react-native';

import {
  elRed,
  elGray,
  elLightGray
} from '../../styles/colors';

export const ButtonContainer = styled(View)`

`;

export const AssetsContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AssetsShowContainer = styled(View)`
  display: flex;

  border: 4px solid black;
  border-radius: 10px;
  padding: 20px;
  gap: 40px;
  min-height: 200px;
`;

export const AssetDetailsContainer = styled(View)`
flex-direction: row;
`

export const SaleDetailsContainer = styled(View)`
  background-color: ${elLightGray};
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  padding: 10px;
`